import $ from 'jquery';

function initializeBillingSectionPaymentHandlers() {
    $('[data-hide-billing-section-action]').click(function () {
        window.billing.hideBillingSection();
    });
    $('[data-update-later-confirmation-message]').click(function (e) {
        if (
            confirm($(e.target).attr('data-update-later-confirmation-message'))
        ) {
            document.location = $(e.target).attr(
                'data-update-later-redirect-url',
            );
            return false;
        }
    });
    $('[data-cancel-billing-action]').click(function (e) {
        window.billing.recordBillingCancel();
        document.location = $(e.target).attr('data-cancel-billing-action');
        return false;
    });
    $('[data-submit-payment-action]').click(function () {
        window.billing.submitPayment();
    });
    $('[data-enhance-plan-action]').click(function (e) {
        window.billing.switchProBillingPeriod(
            $(e.target).attr('data-switch-pro-url'),
        );
    });
    $('[data-switch-pro-action]').click(function (e) {
        billing.switchProBillingPeriod($(e.target).attr('data-redirect'));
    });
    $('[data-modify-plan-action]').click(function (e) {
        window.parent.location = $(e.target).attr('data-redirect-url');
    });
    $('[data-redirect-parent-action]').click(function (e) {
        window.parent.location = $(e.target).attr('data-redirect-url');
    });
    $('[data-reload-action]').click(function () {
        window.parent.location = window.parent.location.href;
        return false;
    });
}

const bootObj = {
    /**
     * Note: Not all billingData elements will be set within a view, so first test to see if each element exists:
     * if not (or it's "falsey") - the default value will be set in billing.js
     * if it does - pass the value to the appropriate setter where it will be validated and set
     *
     * @param billingData
     */
    initInitialBillingData: function (billingData) {
        if (!billingData) {
            return;
        }

        // Common billing data
        billingData.countryList &&
            window.billing.setCountryList(billingData.countryList);
        billingData.stateList &&
            window.billing.setStateList(billingData.stateList);
        billingData.currencyData &&
            window.billing.setCurrencyDetails(billingData.currencyData);
        billingData.billingPeriod &&
            window.billing.setBillingPeriod(billingData.billingPeriod);

        // Used by Create Pro Account (create-pro-account.html)
        billingData.proAccountData &&
            window.billing.setProDetails(billingData.proAccountData);

        // Used by Plan Feature (billing-section-planfeature.html)
        billingData.planFeatureData &&
            window.billing.setPlanFeatureDetails(billingData.planFeatureData);
        billingData.showDowngradeOfferPopup &&
            window.billing.setDowngradeOfferPopup(
                billingData.showDowngradeOfferPopup,
            ); // defaults to false
    },
    billing: function () {
        $(document).ready(function () {
            // billing-section-planfeature.html
            window.plans.enterprise.init(null, hs.ba.seatSubmitted);

            $('[data-show-teams-pricing-action]').click(function () {
                window.plans.showTeamsPricingPopup();
            });

            hs.ba.plansData &&
                window.plans.setTeamsPricingToken(
                    hs.ba.plansData.switchToTeamsPricingToken,
                );

            if (!hs.ba.showOptionalAddonSection) {
                window.billing.showBillingSection(); // Used in Free to Pro flow
            }

            window.billing.initChangePlanTypePopup();

            // billing.html
            bootObj.initInitialBillingData(hs.ba.billingData);
            window.billing.init();
            window.billing.initAddressValidation();

            // billing-section-plan-totals.html
            $('[data-switch-to-annual-action]').click(function () {
                window.billing.switchToAnnual();
            });

            // billing-section-plan-submit.html
            $('[data-cancel-payment-action]').click(function () {
                window.billing.cancelPayment();
                return false;
            });
            $('[data-show-billing-section-action]').click(function () {
                window.billing.showBillingSection();
                return false;
            });
            $('[data-enhace-plan-action]').click(function () {
                window.billing.enhancePlanNextHook();
            });

            // billing-section-planfeature-pro.html
            $('[data-click-update-billing-price-action]').click(function () {
                window.billing.updatePrice();
            });
            $('[data-change-update-billing-price-action]').change(function () {
                window.billing.updatePrice();
            });

            // billing-section-payment.html
            initializeBillingSectionPaymentHandlers();
        });
    },
    billingHistory: function () {
        $(document).ready(function () {
            window.billing.initChangePlanTypePopup();
            bootObj.initInitialBillingData(hs.ba.billingData);
            window.billing.init();
            window.billing.initAddressValidation();

            // billing-section-payment.html
            initializeBillingSectionPaymentHandlers();
        });
    },
    createProAccount: function () {
        $(document).ready(function () {
            bootObj.initInitialBillingData(hs.ba.billingData);
            window.billing.init();
            window.billing.postLoadHook();
        });
    },
    appBillingForm: function () {
        $(document).ready(function () {
            window.billing.countryList = hs.ba.billingCountries;
            window.billing.stateList = hs.ba.billingStates;
            window.billing.populateCountry();

            // App billing form renders within an iframe, so it is unaffected by the -brandRefresh class on the
            // parent frame's html element
            // TODO: Remove once app directory styling is cleaned up https://hootsuite.atlassian.net/browse/BILLING-4071
            document
                .getElementsByTagName('html')[0]
                .classList.add('-brandRefresh');
        });
    },
    billingComplete: function () {
        $(document).ready(function () {
            $('[data-reload-payment-page-action]').click(function () {
                window.parent.location = window.parent.location.href;
            });
            $('[data-switch-pro-billing-url]').click(function (e) {
                billing.switchProBillingPeriod(
                    $(e.target).attr('data-switch-pro-billing-url'),
                );
            });

            $('[data-continue-to-dashboard-url]').click(function (e) {
                billing.switchProBillingPeriod(
                    $(e.target).attr('data-continue-to-dashboard-url'),
                );
            });

            //billing-complete-confirm.html
            $('[data-return-to-dashboard-action]').click(function (e) {
                window.parent.location = $(e.target).attr('data-redirect-url');
            });
        });
    },
};

export { bootObj as bootFunctions };
